// src/pages/Home.js
import React, { useEffect, useState } from "react";
import { db, auth } from "../firebase";
import {
  collection,
  getDocs,
  addDoc,
  serverTimestamp,
  doc,
  getDoc,
  query,
  orderBy
} from "firebase/firestore";
import SubCard from "../components/SubCard";
import { Container, Button, Form, Modal } from "react-bootstrap";
import { FaUpload } from "react-icons/fa6";
import { FaPen, FaShare } from "react-icons/fa";
import mixpanel from "mixpanel-browser";

export default function Home() {
  const [subs, setSubs] = useState([]);

  // ✍️ New post state
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [posting, setPosting] = useState(false);

  const [showCreateModal, setShowCreateModal] = useState(false);

  const [index, setIndex] = useState(0);

  // 📥 Fetch subs
  const fetchSubs = async (focusId = null) => {
  const q = query(
    collection(db, "subs"),
    orderBy("createdAt", "desc") // ✅ newest first
  );

  const querySnapshot = await getDocs(q);

  const data = querySnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }));

  setSubs(data);

  // 👇 keep user on edited sub
  if (focusId) {
    const newIndex = data.findIndex(s => s.id === focusId);
    if (newIndex !== -1) {
      setIndex(newIndex);
    }
  }
};

  useEffect(() => {
    fetchSubs();
      mixpanel.track("Feed Viewed");
  }, []);

  useEffect(() => {
  if (!subs.length) return;

  const currentSub = subs[index];

  // 👁️ Track which sub is being viewed
  mixpanel.track("Sub Viewed", {
      subId: currentSub?.id,
      index,
      hasUser: !!currentSub?.userId,
    });

    // 📊 Track how deep user is in feed
    mixpanel.track("Feed Depth", {
      index,
    });

  }, [index, subs]);

  // 🚀 Create sub
  const handleCreateSub = async (e) => {
    e.preventDefault();

    mixpanel.track("Sub Created", {
      has_title: !!title,
      content_length: content.length,
    });

    const user = auth.currentUser;

    if (!user) {
      alert("Login required");
      return;
    }

    if (!content.trim()) {
      alert("Write something first");
      return;
    }

    setPosting(true);

    try {
      // ✅ GET STORED USERNAME
      const userRef = doc(db, "subusers", user.uid);
      const userSnap = await getDoc(userRef);

      let username = "Anonymous";

      if (userSnap.exists()) {
        username = userSnap.data().username;
      }

      // 👇 create a local post FIRST
      const newPost = {
        id: "temp-" + Date.now(), // temp id
        title,
        content,
        createdAt: { seconds: Date.now() / 1000 },
        createdAtLocal: Date.now(),
        avgResistance: 0,
        totalTests: 0,
        userId: user.uid,
        username,
        userPhoto: user.photoURL
      };

      // ⚡ instantly show it at top
      setSubs((prev) => [newPost, ...prev]);

      await addDoc(collection(db, "subs"), {
        title,
        content,
        createdAt: serverTimestamp(),
        createdAtLocal: Date.now(),
        avgResistance: 0,
        totalTests: 0,

        userId: user.uid,
        username: username,
        userPhoto: user.photoURL
      });

      // clear inputs
      setTitle("");
      setContent("");

      // refresh feed
      fetchSubs();

    } catch (err) {
      console.error(err);
      alert("Failed to post");
    }

    setPosting(false);
  };

  const handleSwipe = (direction) => {
    mixpanel.track("Sub Swiped", {
      direction,
    });
    if (direction === "left") {
      setIndex((prev) => (prev + 1) % subs.length);
      
    }

    if (direction === "right") {
      setIndex((prev) =>
        prev === 0 ? subs.length - 1 : prev - 1
      );
    }
  };

  if (subs.length === 0) return <div>Loading...</div>;


 return (
    <div
  style={{
    height: "95vh",
    width: "100%",
    background: "#000",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }}
>
  {/* 📱 APP FRAME (mobile + desktop friendly) */}
  <div
    style={{
      width: "100%",
      maxWidth: "420px", // 👈 key for desktop
      height: "100%",
      position: "relative",
      overflow: "hidden",
      background: "#000"
    }}
  >

      <div
  style={{
    position: "absolute",
    top: "env(safe-area-inset-top, 20px)", // 👈 iPhone safe area
    left: 16,
    right: 16,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    pointerEvents: "none",
    zIndex: 10
  }}
>
  <div style={{ width: 42, height: 42 }} />

  <button
    onClick={() => {
      setShowCreateModal(true);
        mixpanel.track("Open Create Modal");
    }}
    style={{
      pointerEvents: "auto",
      width: 45,
      height: 45,
      borderRadius: "50%",
      background: "rgba(255,255,255,0.12)",
      backdropFilter: "blur(10px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
      transition: "all 0.25s ease",
      marginTop: 15,
      cursor: "pointer",
    }}
  >
    {/* <FaPen /> */}
    <img 
      src="/talkw.png"
      alt="create"
      style={{ width: 23, filter: "invert(0.5)" }}
     />
  </button>
</div>


      <SubCard
        key={subs[index].id}
        sub={subs[index]}
        onSwipe={handleSwipe}
        nextSub={subs[(index + 1)]} // pass next sub for preloading
        // index={subs[index]}
        onEditSuccess={(id) => fetchSubs(id)}
      />

   

          {/* ✍️ CREATE MODAL */}
    <Modal
      show={showCreateModal}
      onHide={() => setShowCreateModal(false)}
      centered
    >
      <div
        style={{
          background: "rgba(255,255,255,0.95)",
          backdropFilter: "blur(20px)",
          borderRadius: "20px",
          padding: "20px",
          maxHeight: "80vh",       // 👈 important
          overflowY: "auto"
        }}
      >
        {/* <h5 style={{ textAlign: "center", marginBottom: 15 }}>
          Create Subliminal
        </h5> */}

        <Form
          onSubmit={async (e) => {
            await handleCreateSub(e);
            setShowCreateModal(false); // close after post
          }}
        >
          <Form.Control
            as="textarea"
            rows={9}
            placeholder="Write a powerful secret affirmation... "
            value={content}
            onChange={(e) => {
              setContent(e.target.value);
                if (e.target.value.length === 1) {
                  mixpanel.track("Started Writing Sub");
                }
              }}
            style={{
              borderRadius: 12,
              marginBottom: 16,
              border: "1px solid #ccc",
            }}
          />

          <button
            type="submit"
            disabled={posting}
            style={{
              width: "100%",
              background: "linear-gradient(135deg, #ff3b3b, #b30000)",
              color: "white",
              border: "none",
              borderRadius: "12px",
              padding: "12px",
              fontSize: "16px",
              boxShadow: "0 6px 20px rgba(255, 0, 0, 0.35)",
              transition: "all 0.25s ease",
            }}
          >
            {/* {posting ? "Posting..." : "Share"}  */}
            {/* <img 
              src="/send.png"
              alt="send"
              style={{ width: 18, marginLeft: 8, filter: "invert(1)" }}
             /> */}
             Post
          </button>
        </Form>
      </div>
    </Modal>

  </div>
    
    </div>
  );

}